import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeRmsActions } from "stores/jarvisPrime/jarvisPrimeRms/jarvisPrimeRmsActions";

const mapStateToProps = (state) => {
  const {
    sell,
    buy,
    isLoading,
    hasRmsData,
    isBuyCallEnabled,
  } = state.jarvisPrime.primeRMS;
  return {
    sell,
    buy,
    isLoading,
    hasRmsData,
    isBuyCallEnabled,
    profileData: state.customer.profile,
    brokersList: state.common.brokers,
    isBrokersListLoading: state.common.loading.brokers,
    isBrokersListInitialCalled: state.common.initialCalled.brokers,
    centrumReferalURL: state.common.featureConfig.centrumReferalURL
  }
  
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getRMSDetailsAction: jarvisPrimeRmsActions.getRMSDetails,
        getBrokersAction: commonActions.getBrokers,
    },
    dispatch
  );

const PrimeRmsStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default PrimeRmsStore;
